export const SENT = 'Enviado'
export const NOT_SENT = 'NoEnviado'

export const DELIVERY_STATUS_FILTERS = [
  { key: SENT, name: 'Enviado' },
  { key: NOT_SENT, name: 'No Enviado' }
]